import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CotecnaUserService } from "@cotecna/session";
import { TicketingService, TicketingSettings } from "@cotecna/ticketing";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ReportIssueService extends TicketingService {
  constructor(
    protected override httpClient: HttpClient,
    protected override dialog: MatDialog,
    private connectedUserService: CotecnaUserService,
  ) {
    const ticketingSettings: TicketingSettings = {
      automaticScreenshotEnabled: true,
      manualUploadEnabled: false,
    };
    super(httpClient, dialog, ticketingSettings);
  }

  protected setRequestorEmail(): string {
    const user = this.connectedUserService.getUser();

    return user.email;
  }

  protected getBaseUrl(): string {
    return environment.webApiUrl;
  }
}
